export const getCartQuantityLimits = product => {
    const minimum = Math.max(1, Math.ceil(Number(product.OrderMinimumQuantity) || 1));
    const maximums = [];
    if (Number(product.OrderMaximumQuantity) > 0) maximums.push(Math.floor(Number(product.OrderMaximumQuantity)));
    if (product.SelectedVariantId && product.SelectedVariantStock != null && Number.isFinite(Number(product.SelectedVariantStock))) maximums.push(Math.max(0, Math.floor(Number(product.SelectedVariantStock))));
    return {minimum, maximum: maximums.length ? Math.min(...maximums) : Infinity};
};
export const changeCartItemQuantity = (items, product, change) => {
    const item = items.find(value => String(value.ProductId) === String(product.ProductId));
    if (!item) throw new Error('This item is no longer in your cart.');
    const quantity = Number(item.Quantity) + change;
    const {minimum, maximum} = getCartQuantityLimits(product);
    if (!Number.isSafeInteger(quantity)) throw new Error('Select a valid quantity.');
    if (quantity < minimum) throw new Error('Minimum quantity for this product is ' + minimum + '.');
    if (quantity > maximum) throw new Error('Maximum available quantity for this product is ' + maximum + '.');
    return items.map(value => String(value.ProductId) === String(product.ProductId) ? {...value, Quantity: quantity} : value);
};
